import { Client } from "@henrotaym/api-client";
import { ContactCredential } from "@spa/api/app/credentials";
import setup from "@spa/setup";

class Type
{
    /** @type {Client} */
    client;

    constructor() {
        this.client = new Client(new ContactCredential)
    }

    /**
     * Getting contact types with name identifier only.
     * @returns {Array<import('@spa/types/api/app/contact').ContactTypeNameOnlyInterface>}
     */
    staticIndex() {
        return [
            { name: "customer" },
            { name: "external_collaborator" },
            { name: "provider" }
        ]
    }

    /**
     * Getting contact types with name identifier only.
     * @returns {Array<import('@spa/types/api/app/contact').ContactTypeNameAndTranslationInterface>}
     */
     translatedStaticIndex() {
        return this.staticIndex().map(type => ({ ...type, label: setup.i18n.t(`components.contacts.types.${type.name}`) }));
    }

    /**
     * Translating given types.
     * @param  {Array<import('@spa/types/api/app/contact').LabellizedContactTypeInterface>} types Types to translate.
     */
    translate(types) {
        const translatedTypes = this.translatedStaticIndex();
        return types.map(type => ({ 
            ...type,
            label: translatedTypes.find(translatedType => translatedType.name === type.name)?.label
        }))
    }
}

export default Type;